export default __webpack_public_path__ + "static/media/4.9e1022e4.jpg";